import { render, staticRenderFns } from "./support.vue?vue&type=template&id=6c8bdfc2&scoped=true&"
import script from "./support.vue?vue&type=script&lang=js&"
export * from "./support.vue?vue&type=script&lang=js&"
import style0 from "./support.vue?vue&type=style&index=0&id=6c8bdfc2&scoped=true&lang=css&"
import style1 from "./support.vue?vue&type=style&index=1&id=6c8bdfc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8bdfc2",
  null
  
)

export default component.exports